export default __webpack_public_path__ + "assets/nigeria-flag.png";